import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faFile,
  faFileInvoiceDollar,
  faPrint,
  faShoppingCart,
  faUndoAlt,
  faSignOutAlt,
  faCircleXmark,
  faRefresh,
  faTrashArrowUp,
  faClockRotateLeft,
  faCartArrowDown,
  faCartShopping,
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import Reimpressao from "./Reimpressao";
import { Button, Modal } from "antd";
import Cancelamento from "./Cancelamento";
import TelaVendas from "./TelaVendas";
import Orcamentos from "./Orcamentos/Orcamentos";
import Devolucao from "./Devolucao";
import Log from "./Log/Log";
import { useConfigQuery } from "../../../queries/useConfig";
import axios from "axios";

const Vendas = () => {
  const { data: config, error } = useConfigQuery();
  const [key, setKey] = React.useState(0);

  const [isModalVisible, setIsModalVisible] = useState(false);

  // ✅ em vez de guardar JSX "congelado", guarda só QUAL tela abrir
  const [modalKey, setModalKey] = useState(null);

  const [pagamentoConcluido, setPagamentoConcluido] = useState(false);
  const [pagamentos, setPagamentos] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [consumidorIdentificado, setConsumidorIdentificado] = useState(false);
  const [consumidor, setConsumidor] = useState(null);

  const [msgSairTela, setMsgSairTela] = useState("");
  const accessToken = window.localStorage.getItem("accessToken");
  const [loading, setLoading] = useState(false);
  const [pagItem, setPagItem] = useState([]);


  const resetStates = () => {
    setProdutos([]);
    setKey((prevKey) => prevKey + 1);
  };

  const bloquearAcesso = (palavra) => {
    if (!palavra) return false;

    const bloqueios = config?.bloqueiosDoUsuario;
    if (!bloqueios) return false;

    return bloqueios.toLowerCase().includes(String(palavra).toLowerCase());
  };

  // ✅ agora abre por "key" (vendas, orcamentos, etc.)
  const handleOpenModal = (key) => {
    setModalKey(key);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setModalKey(null);
  };

  const recuperarVenda = async () => {
    try {
      setLoading(true);
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };

      const { data } = await axios.get(
        `https://techspdv-api-d3e739785e34.herokuapp.com/v1/venda-abandonada/${config?.idLoja}/${modalKey}`,
        options
      );

      const itens = Array.isArray(data?.produtos) ? data.produtos : [];
      setProdutos(itens.map((p) => ({ ...p })));
      setPagamentoConcluido(data?.pagamentoConcluido);
      setPagamentos(data?.pagamentos);
      setConsumidor(data?.consumidor);
      setConsumidorIdentificado(data?.consumidorIdentificado);
      setPagItem(data?.pagItem);



      setLoading(false);
    } catch (error) {
      console.log("Erro recuperarVenda:", error);
      setProdutos([]);
      setLoading(false);
    }
  };

  const handleExitClick = async () => {
    const confirmExit = window.confirm(`${msgSairTela}`);

    if (confirmExit) {
      if (modalKey === "vendas" || modalKey === "orcamentos") {
        try {
          const options = {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          };

          const abandono = await axios.put(
            `https://techspdv-api-d3e739785e34.herokuapp.com/v1/venda-abandonada/${config?.idLoja}/${modalKey}`,
            {
              produtos: produtos, pagamentoConcluido: pagamentoConcluido, pagamentos: pagamentos, consumidor: consumidor, consumidorIdentificado: consumidorIdentificado,
              pagItem: pagItem
            },
            options
          );

          console.log(abandono.data);
        } catch (error) {
          console.log("Erro ao salvar abandono:", error);
        }
      }

      resetStates();
      handleCloseModal();
    }
  };

  // ✅ evita "stale state" quando adiciona rápido
  const trataProdutos = (produto) => {
    setProdutos((prev) => [...prev, produto]);
  };

  return (
    <Container key={key}>
      <Button
        style={{ ...styles.buttonStyled, backgroundColor: "#841584" }}
        onClick={() => {
          handleOpenModal("vendas");
          setMsgSairTela("Deseja abandonar a Venda?");
        }}
        disabled={bloquearAcesso("ve.vendas")}
      >
        <FontAwesomeIcon icon={faShoppingCart} size="2x" />
        <ButtonText>Vendas</ButtonText>
      </Button>

      <Button
        onClick={() => {
          handleOpenModal("orcamentos");
          setMsgSairTela("Deseja abandonar o Orçamento?");
        }}
        disabled={bloquearAcesso("ve.orcamentos")}
        style={{ ...styles.buttonStyled, backgroundColor: "#FFA500" }}
      >
        <FontAwesomeIcon icon={faFileInvoiceDollar} size="2x" />
        <ButtonText>Orçamentos</ButtonText>
      </Button>

      <Button
        onClick={() => {
          handleOpenModal("cancelamento");
          setMsgSairTela("Deseja sair da tela de Cancelamento?");
        }}
        disabled={bloquearAcesso("ve.cancelamento")}
        style={{ ...styles.buttonStyled, backgroundColor: "#FF6347" }}
      >
        <FontAwesomeIcon icon={faCircleXmark} size="2x" />
        <ButtonText>Cancelamento</ButtonText>
      </Button>

      <Button
        onClick={() => {
          handleOpenModal("devolucao");
          setMsgSairTela("Deseja sair da tela de Devolução?");
        }}
        disabled={bloquearAcesso("ve.devolucao")}
        style={{ ...styles.buttonStyled, backgroundColor: "#4682B4" }}
      >
        <FontAwesomeIcon icon={faUndoAlt} size="2x" />
        <ButtonText>Devolução</ButtonText>
      </Button>

      <Button
        onClick={() => {
          handleOpenModal("reimpressao");
          setMsgSairTela("Deseja sair da tela de Reimpressão?");
        }}
        disabled={bloquearAcesso("ve.reimpressao")}
        style={{ ...styles.buttonStyled, backgroundColor: "#32CD32" }}
      >
        <FontAwesomeIcon icon={faPrint} size="2x" />
        <ButtonText>Reimpressão</ButtonText>
      </Button>

      <Button
        onClick={() => {
          handleOpenModal("log");
          setMsgSairTela("Deseja sair da tela de Logs?");
        }}
        disabled={bloquearAcesso("ve.log")}
        style={{
          ...styles.buttonStyled,
          backgroundColor: "#000",
          opacity: "0.5",
        }}
      >
        <FontAwesomeIcon icon={faFile} size="2x" />
        <ButtonText>Log</ButtonText>
      </Button>

      <Modal
        visible={isModalVisible} // AntD v4. Se for v5: open={isModalVisible}
        onCancel={handleExitClick}
        footer={null}
        width="100%"
        style={{ top: 0 }}
        centered
        closeIcon={null}
        className="full-screen-modal"
      >
        <ModalHeader>
          <Button
            type="primary"
            onClick={handleExitClick}
            style={{ backgroundColor: "black", borderColor: "black" }}
          >
            <span style={styles.buttonText}>
              Abandonar <FontAwesomeIcon icon={faSignOutAlt} />
            </span>
          </Button>

          {/* ✅ só mostra quando não tem produtos E está em vendas/orçamentos */}
          {produtos.length === 0 &&
            (modalKey === "vendas" || modalKey === "orcamentos") && (
              <Button
                type="primary"
                onClick={recuperarVenda}
                style={{ backgroundColor: "black", borderColor: "black" }}
                loading={loading}
              >
                <span style={styles.buttonText}>
                  <FontAwesomeIcon icon={faClockRotateLeft} />
                 {' - Recuperar Última Abandonada'}
                </span>
              </Button>
            )}
        </ModalHeader>

        <ModalBody>
          {modalKey === "vendas" && (
            <TelaVendas
              produtos={produtos}
              setProdutos={setProdutos}
              trataProdutos={trataProdutos}
              pagamentoConcluido={pagamentoConcluido}
              setPagamentoConcluido={setPagamentoConcluido}
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              consumidorIdentificado={consumidorIdentificado}
              setConsumidorIdentificado={setConsumidorIdentificado}
              consumidor={consumidor}
              setConsumidor={setConsumidor}
              pagItem={pagItem}
              setPagItem={setPagItem}
            />
          )}

          {modalKey === "orcamentos" && <Orcamentos
            produtos={produtos}
            setProdutos={setProdutos}
            trataProdutos={trataProdutos}
            pagamentoConcluido={pagamentoConcluido}
            setPagamentoConcluido={setPagamentoConcluido}
            pagamentos={pagamentos}
            setPagamentos={setPagamentos}
            consumidorIdentificado={consumidorIdentificado}
            setConsumidorIdentificado={setConsumidorIdentificado}
            consumidor={consumidor}
            setConsumidor={setConsumidor}
            pagItem={pagItem}
            setPagItem={setPagItem} />}
          {modalKey === "cancelamento" && <Cancelamento />}
          {modalKey === "devolucao" && <Devolucao />}
          {modalKey === "reimpressao" && <Reimpressao />}
          {modalKey === "log" && <Log />}
        </ModalBody>
      </Modal>
    </Container>
  );
};

const styles = {
  buttonStyled: {
    width: "150px",
    height: "150px",
    border: "none",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: "16px",
    margin: "10px",
  },
  buttonText: {
    color: "#fff",
    fontWeight: "bold",
  },
};

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  height: 100vh;
  position: relative;
  width: 100%;
`;

const ButtonText = styled.span`
  margin-top: 10px;
  font-weight: bold;
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 0;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between; /* cada um em uma ponta */
  align-items: center;
  padding: 8px 12px;
  background: #fff;
  width: 100%;
`;

const ModalBody = styled.div`
  padding: 0;
  margin: 0;
  height: 92vh;
  width: 100%;
`;

export default Vendas;
